export default "__VITE_ASSET__DWPfVu3Z__"